/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import * as follow_tags from '@fof-follow-tags';

// The slice of fof/follow-tags this extension reaches for, beyond what orell-thalia-common's
// ambient declaration of the module already covers. Intersected locally rather than re-declared,
// since the surface is not ours to keep in sync — as in `forum/utils/foreignApis.ts`.

/** The section of follow-tags' locale namespace an options map is labelled under. */
export type FollowingSection = 'forum.index.following' | 'admin.settings';

/** follow-tags' following-page options map: filter name → label. */
export type FollowingPageOptions = Record<string, any>;

export const followTagsUtils = follow_tags.utils as typeof follow_tags.utils & {
	/** The following-page filter dropdown's options, replaced in `common/helpers/followingPageOptions`. */
	followingPageOptions: (section: FollowingSection) => FollowingPageOptions;

	/** The filter the following page falls back to before the user picks one. */
	getDefaultFollowingFiltering(): string;
};

export const followTagsComponents = follow_tags.components as typeof follow_tags.components & {
	/** The tag subscribe/unsubscribe menu, rendered into the reviews page hero. */
	SubscriptionMenu: any;
};
